export default __webpack_public_path__ + "static/pause-e662875afffb5fcec9903d52a7627301.png";